import { render, staticRenderFns } from "./expert_order.vue?vue&type=template&id=c60a07e8&scoped=true"
import script from "./expert_order.vue?vue&type=script&lang=js"
export * from "./expert_order.vue?vue&type=script&lang=js"
import style0 from "./expert_order.vue?vue&type=style&index=0&id=c60a07e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60a07e8",
  null
  
)

export default component.exports